import { forwardRef as s } from "react";
import { jsx as c } from "react/jsx-runtime";
const p = s((r, e) => {
  const {
    href: n,
    internal_link: t,
    open_in_new_tab: o,
    children: a,
    style: i,
    className: l
  } = r;
  return /* @__PURE__ */ c("a", {
    ref: e,
    href: n,
    rel: t ? void 0 : "noreferrer",
    target: o ? "_blank" : void 0,
    style: i,
    className: l,
    children: a
  });
});
export {
  p as Link
};
